const ERRORCODE = {
	NOTFOUND: 'NOTFOUND',
	UNAUTHORIZED_DEACTIVATED: 'UNAUTHORIZED_DEACTIVATED',
	UNAUTHORIZED_DEFAULT: 'UNAUTHORIZED_DEFAULT',
};

const PRICING_PAGE = '/pricing';

const TWO_YEARS_IN_S = 63_072_000;

module.exports = {
	ERRORCODE,
	PRICING_PAGE,
	TWO_YEARS_IN_S,
};
